// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/associations.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/model/core/associations.proto.
 */
export const file_proto_model_core_associations = /*@__PURE__*/
  fileDesc("CiNwcm90by9tb2RlbC9jb3JlL2Fzc29jaWF0aW9ucy5wcm90bxIGY2FybWVuIpoBCgxBc3NvY2lhdGlvbnMSKwoHY3JlYXRlZBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIbW9kaWZpZWQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi8KD3N0cmlwZV9jdXN0b21lchgDIAEoCzIWLmNhcm1lbi5TdHJpcGVDdXN0b21lciJiCg5TdHJpcGVDdXN0b21lchITCgtjdXN0b21lcl9pZBgBIAEoCRIrCgdjcmVhdGVkGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIOCgZhY3RpdmUYAyABKAhCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Describes the message carmen.Associations.
 * Use `create(AssociationsSchema)` to create a new message.
 */
export const AssociationsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_associations, 0);

/**
 * Describes the message carmen.StripeCustomer.
 * Use `create(StripeCustomerSchema)` to create a new message.
 */
export const StripeCustomerSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_associations, 1);

